// extracted by mini-css-extract-plugin
module.exports = {"titles":"formuser_titles__3a5pR"};